// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/get_experiment_data_response.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExperimentData } from "./experiment_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_data } from "./experiment_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/get_experiment_data_response.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_data_response: GenFile = /*@__PURE__*/
  fileDesc("CkpxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZ2V0X2V4cGVyaW1lbnRfZGF0YV9yZXNwb25zZS5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIoYBChlHZXRFeHBlcmltZW50RGF0YVJlc3BvbnNlElUKD2V4cGVyaW1lbnRfZGF0YRgBIAEoCzI3LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5FeHBlcmltZW50RGF0YUgAiAEBQhIKEF9leHBlcmltZW50X2RhdGFiBnByb3RvMw", [file_quanterix_simoa_one_analysis_app_api_v1_experiment_data]);

/**
 * Rpc response containing Experiment data
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.GetExperimentDataResponse
 */
export type GetExperimentDataResponse = Message<"quanterix.simoa_one.analysis_app_api.v1.GetExperimentDataResponse"> & {
  /**
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentData experiment_data = 1;
   */
  experimentData?: ExperimentData;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.GetExperimentDataResponse.
 * Use `create(GetExperimentDataResponseSchema)` to create a new message.
 */
export const GetExperimentDataResponseSchema: GenMessage<GetExperimentDataResponse> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_data_response, 0);

